var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2392_21849)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 2.39909C16.4188 2.39909 16.1812 2.49754 16.0059 2.67278L8.25248 10.4262L7.81198 12.1882L9.57397 11.7477L17.3274 3.99427C17.5027 3.81903 17.6011 3.58135 17.6011 3.33352C17.6011 3.0857 17.5027 2.84802 17.3274 2.67278C17.1522 2.49754 16.9145 2.39909 16.6667 2.39909ZM14.8274 1.49427C15.3152 1.00647 15.9768 0.732422 16.6667 0.732422C17.3565 0.732422 18.0181 1.00647 18.5059 1.49427C18.9937 1.98207 19.2678 2.64367 19.2678 3.33352C19.2678 4.02338 18.9937 4.68498 18.5059 5.17278L10.5893 13.0894C10.4825 13.1962 10.3486 13.272 10.2021 13.3086L6.86879 14.142C6.58481 14.213 6.2844 14.1298 6.07742 13.9228C5.87044 13.7158 5.78723 13.4154 5.85822 13.1314L6.69156 9.79808C6.72819 9.65155 6.80396 9.51773 6.91075 9.41093L14.8274 1.49427ZM1.56558 3.23242C2.03442 2.76358 2.6703 2.50019 3.33334 2.50019H9.16668C9.62691 2.50019 10 2.87328 10 3.33352C10 3.79376 9.62691 4.16686 9.16668 4.16686H3.33334C3.11233 4.16686 2.90037 4.25465 2.74409 4.41093C2.58781 4.56721 2.50001 4.77917 2.50001 5.00019V16.6669C2.50001 16.8879 2.58781 17.0998 2.74409 17.2561C2.90037 17.4124 3.11233 17.5002 3.33334 17.5002H15C15.221 17.5002 15.433 17.4124 15.5893 17.2561C15.7455 17.0998 15.8333 16.8879 15.8333 16.6669V10.8335C15.8333 10.3733 16.2064 10.0002 16.6667 10.0002C17.1269 10.0002 17.5 10.3733 17.5 10.8335V16.6669C17.5 17.3299 17.2366 17.9658 16.7678 18.4346C16.2989 18.9035 15.6631 19.1669 15 19.1669H3.33334C2.6703 19.1669 2.03442 18.9035 1.56558 18.4346C1.09674 17.9658 0.833344 17.3299 0.833344 16.6669V5.00019C0.833344 4.33715 1.09674 3.70126 1.56558 3.23242Z",
    fill: "#0070B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2392_21849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.751e2666f7200e7e5cb4112749c0d7bb.svg";
export { ForwardRef as ReactComponent };